import React, { createElement, isValidElement, useEffect } from 'react';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, isContentfulString, isEnumValid, resolveBackgroundColor, resolveColor, resolveHSLColor, } from '@philips-internal/oswald-ui-utils';
import { InlineImage } from '../../inline-image/inline-image.js';
import { LegendsSize } from '../legends-constants.js';
import { useOptionalLegends } from '../legends-context.js';
import { LegendItemProperties } from './legend-item-types.js';
import './legend-item.css';
function LegendIcon(props) {
    const style = resolveBackgroundColor(props.color);
    if (isValidElement(props.icon)) {
        const className = classNames({
            [`${props.icon.props.className}`]: Boolean(props.icon.props.className),
        });
        return (React.createElement("div", { className: "c-legend-item__icon" }, createElement(props.icon.type, {
            ...props.icon.props,
            className,
            style: {
                fill: resolveHSLColor(props.color),
            },
        })));
    }
    if (isContentfulString(props.icon)) {
        return (React.createElement(InlineImage, { className: "c-legend-item__icon", imageAlt: MessageService.translate('tws.legend-item.icon-alt', { label: props.label }), src: props.icon, style: resolveColor(props.color) }));
    }
    return (React.createElement("div", { className: "c-legend-item__icon c-legend-item__icon--rounded", style: style }));
}
function LegendItem(props) {
    const legends = useOptionalLegends();
    const size = legends?.size ?? props.size ?? LegendItemProperties.size.defaultValue;
    const { color, value, hideLabel, icon, label, notifyLegends = LegendItemProperties.notifyLegends.defaultValue, } = props;
    useEffect(() => {
        if (!legends || !notifyLegends || !value) {
            return;
        }
        legends.addItem(props);
        return () => {
            legends?.removeItem(value);
        };
    }, [color, value, icon, label, notifyLegends, legends?.addItem, legends?.removeItem]);
    const className = classNames({
        'c-legend-item': true,
        [`c-legend-item--${size}`]: isEnumValid(LegendsSize, size),
    });
    const text = label ?? value ?? '';
    return (React.createElement("div", { className: className },
        React.createElement(LegendIcon, { color: color, icon: icon, label: text }),
        !hideLabel && text ? (React.createElement("span", { className: "c-legend-item__text" }, MessageService.translate(text))) : null));
}
export { LegendItem, };
//# sourceMappingURL=legend-item.js.map